import createIcon from '../../createIcon';

/**
 * @component @name Nature
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuOTE1IDE2LjAzNTlDMTYuMzg1IDE1LjYyNTkgMTkuMDg1IDEyLjY3NTkgMTkuMDg1IDkuMDg1OTRDMTkuMDg1IDUuMjE1OTQgMTUuOTU1IDIuMDg1OTQgMTIuMDg1IDIuMDg1OTRDOC4yMTUwNCAyLjA4NTk0IDUuMDg1MDQgNS4yMTU5NCA1LjA4NTA0IDkuMDg1OTRDNS4wODUwNCAxMi41NTU5IDcuNjA1MDQgMTUuNDI1OSAxMC45MTUgMTUuOTc1OVYxOS45MTU5SDQuOTE1MDRWMjEuOTE1OUgxOC45MTVWMTkuOTE1OUgxMi45MTVWMTYuMDM1OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Nature = createIcon('Nature', [
  [
    'path',
    {
      d: 'M12.915 16.0359C16.385 15.6259 19.085 12.6759 19.085 9.08594C19.085 5.21594 15.955 2.08594 12.085 2.08594C8.21504 2.08594 5.08504 5.21594 5.08504 9.08594C5.08504 12.5559 7.60504 15.4259 10.915 15.9759V19.9159H4.91504V21.9159H18.915V19.9159H12.915V16.0359Z',
      key: '1piowu',
    },
  ],
]);

export default Nature;
